import { gql } from "@apollo/client";

export const OFFER_STEPS_CHANGED = gql`
    subscription offerStepsChanged($documentId: Int!, $siteId: Int!) {
        offerStepsChanged(documentId: $documentId, siteId: $siteId) {
            documentId
            siteId
        }
    }
`;